(function () {
  const pathname = window.location.pathname;
  if (
    pathname.endsWith('/collections') ||
    pathname.endsWith('/collections/') ||
    pathname.endsWith('/collections/all') ||
    pathname.endsWith('/collections/all/') ||
    pathname.endsWith('/products') ||
    pathname.endsWith('/products/')
  ) {
    const baseUrl = pathname.startsWith('/fr') ? '/fr' : '/';
    window.location.replace(baseUrl);
  }
})();
